import { apiRequest } from './api'

export function listCompanies() {
  return apiRequest('/admin/companies/list', {
    method: 'POST',
  })
}

export function createCompany(payload) {
  return apiRequest('/admin/companies/create', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function updateCompany(payload) {
  return apiRequest('/admin/companies/update', {
    method: 'POST',
    body: JSON.stringify(payload),
  })
}

export function deleteCompany(companyId) {
  return apiRequest('/admin/companies/delete', {
    method: 'POST',
    body: JSON.stringify({ companyId }),
  })
}
